module.exports = __webpack_public_path__ + "img/acc-logo-footer.png";